(function () {
  'use strict';

  function initHeaderSparkles() {
    var canvas = document.getElementById('sancti-header-sparkles');
    if (!canvas) return;

    var ctx = canvas.getContext('2d');
    var W, H, particles = [];

    function resize() {
      var wrapper = canvas.closest ? canvas.closest('.header-wrapper') : canvas.parentElement;
      W = canvas.width = wrapper ? wrapper.offsetWidth : window.innerWidth;
      H = canvas.height = wrapper ? wrapper.offsetHeight : 80;
    }

    function Particle() { this.reset(true); }
    Particle.prototype.reset = function (initial) {
      this.x = Math.random() * (W || 800);
      this.y = initial ? Math.random() * (H || 80) : (H || 80) + 5;
      this.vx = (Math.random() - 0.5) * 0.2;
      this.vy = -(Math.random() * 0.22 + 0.07);
      this.size = Math.random() * 2 + 0.4;
      this.life = initial ? Math.floor(Math.random() * 200) : 0;
      this.maxLife = Math.random() * 220 + 80;
      this.opacity = 0;
      this.maxOp = Math.random() * 0.5 + 0.08;
      this.twinkle = Math.random() * 0.07 + 0.02;
      this.twinklePhase = Math.random() * Math.PI * 2;
      this.isStar = Math.random() < 0.18;
    };

    Particle.prototype.update = function () {
      this.life++;
      this.x += this.vx;
      this.y += this.vy;
      var r = this.life / this.maxLife;
      if (r < 0.15) {
        this.opacity = (r / 0.15) * this.maxOp;
      } else if (r < 0.75) {
        this.opacity = this.maxOp * (0.75 + 0.25 * Math.sin(this.life * this.twinkle + this.twinklePhase));
      } else {
        this.opacity = ((1 - r) / 0.25) * this.maxOp;
      }
      if (this.life >= this.maxLife || this.y < -10) this.reset(false);
    };

    Particle.prototype.draw = function () {
      if (this.opacity < 0.005) return;
      ctx.save();
      ctx.globalAlpha = this.opacity;
      if (this.isStar) {
        ctx.strokeStyle = 'rgba(255,245,170,1)';
        ctx.lineWidth = this.size * 0.35;
        ctx.lineCap = 'round';
        var s = this.size * 2.8;
        ctx.beginPath(); ctx.moveTo(this.x - s, this.y); ctx.lineTo(this.x + s, this.y); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(this.x, this.y - s); ctx.lineTo(this.x, this.y + s); ctx.stroke();
        ctx.lineWidth = this.size * 0.15;
        ctx.globalAlpha = this.opacity * 0.45;
        var d = s * 0.6;
        ctx.beginPath(); ctx.moveTo(this.x - d, this.y - d); ctx.lineTo(this.x + d, this.y + d); ctx.stroke();
        ctx.beginPath(); ctx.moveTo(this.x + d, this.y - d); ctx.lineTo(this.x - d, this.y + d); ctx.stroke();
      } else {
        var g = ctx.createRadialGradient(this.x, this.y, 0, this.x, this.y, this.size * 2.2);
        g.addColorStop(0, 'rgba(255,252,200,1)');
        g.addColorStop(0.4, 'rgba(255,215,0,0.7)');
        g.addColorStop(1, 'rgba(255,215,0,0)');
        ctx.fillStyle = g;
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size * 2.2, 0, Math.PI * 2);
        ctx.fill();
      }
      ctx.restore();
    };

    for (var i = 0; i < 40; i++) particles.push(new Particle());

    function loop() {
      ctx.clearRect(0, 0, W, H);
      particles.forEach(function (p) { p.update(); p.draw(); });
      requestAnimationFrame(loop);
    }

    resize();
    window.addEventListener('resize', resize);
    loop();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initHeaderSparkles);
  } else {
    initHeaderSparkles();
  }
})();
